import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Inject,
  ViewChild,
} from '@angular/core';

import { CONNECTED_PLAYER_CLOSE_REQUEST } from '../../tokens/connected-player-close-request';
import { CONNECTED_PLAYER_SRC } from '../../tokens/connected-player-src.token';
import { CONNECTED_PLAYER_VOLUME } from '../../tokens/connected-player-volume.token';

@Component({
  selector: 'bm-connected-video-player',
  templateUrl: 'connected-video-player.component.html',
  styleUrls: ['connected-video-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * Connected video player, to be called using the remote service
 */
export class ConnectedVideoPlayerComponent {
  public autoplay = true;
  public isPlaying!: boolean;
  public src: string;
  public volume: number;

  @ViewChild('videoElement', { read: ElementRef, static: true })
  private _videoElement!: ElementRef<HTMLVideoElement>;

  @ViewChild('fullscreenWrapper', { read: ElementRef, static: true })
  private _fullscreenWrapper!: ElementRef<HTMLElement>;

  @HostBinding('class.focus-within')
  public get focusWithin() {
    return this._focusWithin;
  }

  private _focusWithin = false;

  private _closeRequest: () => void;

  constructor(
    @Inject(CONNECTED_PLAYER_SRC) src: string,
    // tslint:disable-next-line:no-any
    @Inject(CONNECTED_PLAYER_CLOSE_REQUEST) _closeRequest: any,
    // tslint:disable-next-line:no-any
    @Inject(DOCUMENT) private _document: any,
    @Inject(CONNECTED_PLAYER_VOLUME) volume: number,
    private _cdr: ChangeDetectorRef,
  ) {
    this.src = src;
    this._closeRequest = _closeRequest;
    this.volume = volume;
  }

  @HostListener('focusin')
  public onFocusin() {
    this._focusWithin = true;
  }
  @HostListener('focusout')
  public onFocusout() {
    this._focusWithin = false;
  }

  @HostListener('document:keydown', ['$event'])
  public onDocumentKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this._closeRequest();
    }
  }

  public close() {
    this._closeRequest();
  }

  public onMediaEnded() {
    this._closeRequest();
  }

  public checkAfterVideoElement() {
    this._cdr.markForCheck();
  }

  public onVideoPlay() {
    this.isPlaying = true;
    this._cdr.markForCheck();
  }

  public onVideoPause() {
    this.isPlaying = false;
    this._cdr.markForCheck();
  }

  public togglePlay() {
    if (this._videoElement) {
      if (this._videoElement.nativeElement.paused) {
        this._videoElement.nativeElement.play();
      } else {
        this._videoElement.nativeElement.pause();
      }
    }
  }

  public onSliderSeek($event: number) {
    if (this._videoElement) {
      this._videoElement.nativeElement.currentTime = $event;
    }
  }

  public toggleFullScreen() {
    if (
      this._fullscreenWrapper &&
      this._fullscreenWrapper.nativeElement.requestFullscreen
    ) {
      if (this._document.fullscreenElement) {
        this._document.exitFullscreen();
      } else {
        this._fullscreenWrapper.nativeElement
          .requestFullscreen()
          .catch(err => console.error(err));
      }
    }
  }

  public displayFullScreenBtn() {
    return (
      this._fullscreenWrapper &&
      this._fullscreenWrapper.nativeElement.requestFullscreen
    );
  }
}
